// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + "tour" + "." + "95a15a84" + ".chunk.js";
};